<template>
  <div class="manager box" v-if="me">
    <div class="avatar">
      <avatar :username="manager.user.fname + ' ' + manager.user.lname"></avatar>
    </div>

    <div class="name">
      <span>{{ manager.user.fname }} {{ manager.user.lname }}</span>
    </div>

    <div class="email">{{ manager.user.email }}</div>

    <div class="tags">
      <span class="tag admin" v-if="manager.accountmanager === 5">admin</span>
      <span class="tag manager" v-else>manager</span>
    </div>

    <k-dropdown class="actions" v-if="me.id !== manager.user.id">
      <template slot="handler">
        <font-awesome-icon icon="ellipsis-v"></font-awesome-icon>
      </template>
      <k-dropdown-option @click.native="remove">Delete</k-dropdown-option>
    </k-dropdown>
  </div>
</template>

<script>

import Avatar from 'vue-avatar'
import { mapActions, mapGetters } from 'vuex'
import VueDropdown from '@kevindesousa/vue-dropdown'

export default {
  components: {
    Avatar, VueDropdown
  },

  props: ['manager'],

  computed: {
    ...mapGetters('user', {
      me: 'me'
    }),
    ...mapGetters('account', {
      site: 'currentSite'
    })
  },
  methods: {
    ...mapActions('account', ['deleteManager']),

    remove () {
      this.deleteManager({user: this.manager.user}).then(() => {
        this.$notify({
          title: 'Success',
          message: this.$root.$t('notifications.manager.deleted'),
          type: 'success'
        })
      })
    }

  }
}
</script>

<style lang="scss" scopped>
.manager {
  box-sizing: border-box;
  padding:12px;
  width: 100%;
  display: inline-block;
  align-items: center;
  font-size: 14px;
  margin-bottom: 10px;
  display: grid;
  grid-template-columns: 60px 1fr 40px;
  grid-template-rows: 1fr 1fr 1fr;
  grid-template-areas:
      "avatar name actions"
      "avatar email actions"
      "avatar tags actions"
  ;
  grid-column-gap: 24px;
  border-bottom:1px solid #dedede;

  .avatar {
      grid-area: avatar;
  }

  .name {
      grid-area: name;
      font-weight: 600;
  }

  .email {
      grid-area: email;
  }

  .tags {
      grid-area: tags;
  }

  .actions {
      grid-area: actions;
  }
}

.tag {
    display: inline-block;
    width: inherit;
    border-radius: 4px;
    padding:4px 8px;
    color:#fff;
    margin:0;
    font-weight: 400;
    font-size: 13px;
    &.admin {
      background:#3FC380;
    }
    &.manager {
      background:#446CB3;
    }
}
.group-actions {
    text-align: center;
    margin-right: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/settings/settings_managers_manager.vue